import { SidebarDesktop } from './components/Desktop'
import { SidebarMobile } from './components/Mobile'
import { SidebarContext, SidebarProvider } from './contexts/SidebarContext'
import { useSidebar } from './hooks/useSidebar'

export const Sidebar = {
  Desktop: SidebarDesktop,
  Mobile: SidebarMobile,
}

export { SidebarContext, SidebarProvider, useSidebar }
